var BoardInput;
(function (BoardInput) {
    BoardInput["REVEAL"] = "REVEAL";
    BoardInput["FLAG"] = "FLAG";
})(BoardInput || (BoardInput = {}));
export default BoardInput;
